module.exports = __webpack_public_path__ + "static/media/py.2d2b51ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/py.svg
// module id = 231
// module chunks = 0